import React from 'react'

const FooterContent = (props) => {
    return (
        <>
            The Gift Card Granny Visa&reg; Reward Cards are issued by Sutton
            Bank&reg;, Member FDIC, pursuant to a license from Visa U.S.A. Inc.
            No cash access or recurring payments. Card can be used everywhere
            Visa debit cards are accepted. Visa Virtual Account can be redeemed
            at every Internet, mail order, and telephone merchant everywhere
            Visa debit cards are accepted. Terms, conditions and expiration
            apply. The Gift Card Granny Mastercard&reg; Reward Cards are issued
            by Sutton Bank&reg;, Member FDIC, pursuant to a license from
            Mastercard International Incorporated. No cash access or recurring
            payments. Card can be used everywhere Mastercard debit cards are
            accepted. Mastercard Virtual Account can be redeemed at every
            Internet, mail order, and telephone merchant everywhere Mastercard
            debit cards are accepted. Terms, conditions and expiration apply.
        </>
    )
}

export default FooterContent
